import type { BlockRendererRecord } from '@emporion/block-renderer'
import { sanitizeRichHtml } from '../shared/security/sanitizeRichHtml'

export const shopBlockRenderers: BlockRendererRecord = {
  richText: (props) => (
    <article className="prose prose-slate max-w-none rounded-2xl bg-white p-6 shadow-sm">
      <div dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(props.content ?? props.html ?? '') }} />
    </article>
  ),
}
